import { SUBSCRIPTION } from '@algoacademy/backend/modules/marketplace/enums'

export const PAYMENT__OFFER_STATUS = {
  UNPAID: 'unpaid',
  PAID: 'paid'
} as const

export type PaymentOfferStatus = (typeof PAYMENT__OFFER_STATUS)[keyof typeof PAYMENT__OFFER_STATUS]

export const PAYMENT__OFFER_STATUS_DESCRIPTIONS: Record<PaymentOfferStatus, string> = {
  [PAYMENT__OFFER_STATUS.UNPAID]: 'Nieopłacona',
  [PAYMENT__OFFER_STATUS.PAID]: 'Opłacona'
} as const

// Values mirror the mentoring ORDER_TYPE values used by Stripe checkout
// (endpoints/mutations/stripe-checkout/types.ts) so an offer and a checkout
// order describe the same product with the same string.
export const PAYMENT__MENTORING_TYPE = {
  GROUP_MENTORING: 'group-mentoring',
  INDIVIDUAL_MENTORING: 'individual-mentoring',
  PROJECT_MENTORING: 'project-mentoring'
} as const

export type PaymentMentoringType =
  (typeof PAYMENT__MENTORING_TYPE)[keyof typeof PAYMENT__MENTORING_TYPE]

// Public product names from the pricing page (MentoringTabs.tsx) - what a
// buyer sees on checkout, the card statement and CRM events.
export const PAYMENT__MENTORING_TYPE_DESCRIPTIONS: Record<PaymentMentoringType, string> = {
  [PAYMENT__MENTORING_TYPE.GROUP_MENTORING]: 'Mentoring podstawowy',
  [PAYMENT__MENTORING_TYPE.INDIVIDUAL_MENTORING]: 'Mentoring rozszerzony',
  [PAYMENT__MENTORING_TYPE.PROJECT_MENTORING]: 'Mentoring projektowy'
} as const

// Cadence values come straight from the marketplace SUBSCRIPTION enum - one
// source of truth for the strings shown on /mentoring and stored per offer.
export const PAYMENT__BILLING_CADENCE = {
  PER_4_WEEKS: SUBSCRIPTION.PER_4_WEEKS,
  PER_12_WEEKS: SUBSCRIPTION.PER_12_WEEKS,
  YEARLY: SUBSCRIPTION.YEARLY
} as const

export type PaymentBillingCadence =
  (typeof PAYMENT__BILLING_CADENCE)[keyof typeof PAYMENT__BILLING_CADENCE]

export const PAYMENT__BILLING_CADENCE_DESCRIPTIONS: Record<PaymentBillingCadence, string> = {
  [PAYMENT__BILLING_CADENCE.PER_4_WEEKS]: 'Co 4 tygodnie',
  [PAYMENT__BILLING_CADENCE.PER_12_WEEKS]: 'Co 12 tygodni',
  [PAYMENT__BILLING_CADENCE.YEARLY]: 'Co rok'
} as const
